// eslint-disable-next-line import/prefer-default-export
export const TWITTER_COLOR = '#000';

export function getTwitterConfig() {
  return {
    color: TWITTER_COLOR,
  };
}
